import QuotationsApi from '../api/QuotationsApi';
import QuotationsConstants from '../constants/QuotationsConstants';

function addQuotation({ metadataId, quotation, postSuccess }) {
  return {
    metadataId,
    postSuccess,
    types: [
      QuotationsConstants.ADD_QUOTATION_REQUEST,
      QuotationsConstants.ADD_QUOTATION_SUCCESS,
      QuotationsConstants.ADD_QUOTATION_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => QuotationsApi.addQuotation({
      metadataId,
      quotation,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function updateQuotation({ metadataId, quotationId, quotation, postSuccess }) {
  return {
    metadataId,
    quotationId,
    postSuccess,
    types: [
      QuotationsConstants.UPDATE_QUOTATION_REQUEST,
      QuotationsConstants.UPDATE_QUOTATION_SUCCESS,
      QuotationsConstants.UPDATE_QUOTATION_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => QuotationsApi.updateQuotation({
      quotationId,
      quotation,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function removeQuotation({ metadataId, quotationId, postSuccess }) {
  return {
    metadataId,
    quotationId,
    postSuccess,
    types: [
      QuotationsConstants.REMOVE_QUOTATION_REQUEST,
      QuotationsConstants.REMOVE_QUOTATION_SUCCESS,
      QuotationsConstants.REMOVE_QUOTATION_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => QuotationsApi.removeQuotation({
      quotationId,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client),
    apiSuccess: () => ({
      deletedEntities: [`ugc.quotations.${quotationId}`]
    })
  };
}

export default {
  addQuotation,
  updateQuotation,
  removeQuotation
};



// WEBPACK FOOTER //
// ./app/actions/QuotationsActions.js